import { useContext, useEffect } from 'react'
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom'

export function useNavigationBlocker(
  blocker: (tx: { retry: () => void }) => void,
  when: boolean
) {
  const { navigator } = useContext(NavigationContext)

  useEffect(() => {
    if (!when) return

    const originalPush = navigator.push
    const originalReplace = navigator.replace

    navigator.push = (...args: Parameters<typeof originalPush>) => {
      blocker({ retry: () => originalPush(...args) })
    }

    navigator.replace = (...args: Parameters<typeof originalReplace>) => {
      blocker({ retry: () => originalReplace(...args) })
    }

    return () => {
      navigator.push = originalPush
      navigator.replace = originalReplace
    }
  }, [navigator, blocker, when])
}
